var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { CanceledPromiseError, makeCancelablePromise } from '@datocms/rest-client-utils';
import { uploadFileOrBlobToS3 } from './uploadFileOrBlobToS3';
export function uploadFileOrBlobAndReturnPath(client, fileOrBlob, options) {
  var _this = this;

  if (options === void 0) {
    options = {};
  }

  if (!(options.filename && 'name' in fileOrBlob)) {
    throw new Error('Missing filename, please provide it as an option!');
  }

  var filename = options.filename || fileOrBlob.name;
  var isCanceledBeforeUpload = false;
  var uploadPromise = undefined;
  return makeCancelablePromise(function () {
    return __awaiter(_this, void 0, void 0, function () {
      var _a, id, url, request_headers;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (options.onProgress) {
              options === null || options === void 0 ? void 0 : options.onProgress({
                type: 'REQUESTING_UPLOAD_URL',
                payload: {
                  filename: filename
                }
              });
            }

            return [4
            /*yield*/
            , client.uploadRequest.create({
              filename: filename
            })];

          case 1:
            _a = _b.sent(), id = _a.id, url = _a.url, request_headers = _a.request_headers;

            if (isCanceledBeforeUpload) {
              throw new CanceledPromiseError();
            }

            if (options.onProgress) {
              options.onProgress({
                type: 'UPLOADING_FILE',
                payload: {
                  progress: 0
                }
              });
            }

            uploadPromise = uploadFileOrBlobToS3(fileOrBlob, url, __assign(__assign({}, options), {
              additionalHeaders: request_headers
            }));
            return [4
            /*yield*/
            , uploadPromise];

          case 2:
            _b.sent();

            return [2
            /*return*/
            , id];
        }
      });
    });
  }, function () {
    if (uploadPromise) {
      uploadPromise.cancel();
    } else {
      isCanceledBeforeUpload = true;
    }
  });
}